import { localizationService } from "../../localization";
import { AvatarStyle, TooltipInfoFacet, TooltipPlacement } from "flavr-common";
import { Euler, Quaternion, Vector3 } from "flavr-math";
import { localPlayerContainer } from "../../localplayer/LocalPlayerContainer";
import { FacetRenderer } from "../renderable/Renderable";
import { AvatarLoadedMessage, LoadAvatarMessage } from "../../../messages/rendering/RendererMessages";
import { SpeechBubble, SpeechBubbleTextAlingment } from "../speechBubble/speechBubble";
import { renderManager } from "../../xr/RenderManager";
const tmpOrientation = new Quaternion();
const tmpVector3 = new Vector3();
const tmpEuler = new Euler();
export class TooltipInfoRenderer extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.avatarTransNeedsUpdate = true;
        this.anchorPoint = new Vector3();
        owner.setFacetVisible(this.facetType, false);
    }
    setVisible(visible) {
        if (visible && (this.facet !== undefined) && this.facet.placement !== TooltipPlacement.CONTROLLER) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    destroy() {
        this.hide();
    }
    updateFacet(newTooltipInfo) {
        const oldTooltipInfo = this.facet;
        if (newTooltipInfo.placement === TooltipPlacement.CONTROLLER) {
            this.destroy();
            return;
        }
        if (this.speechBubble === undefined) {
            this.speechBubble = new SpeechBubble(this.owner.renderer, this.owner.modelUID);
        }
        this.speechBubble.setText(localizationService.getTranslation(newTooltipInfo.text));
        const oldAvatar = (oldTooltipInfo !== undefined) ? oldTooltipInfo.avatar : undefined;
        const avatarChanged = newTooltipInfo.avatar !== oldAvatar;
        if (avatarChanged) {
            this.speechBubble.removeAvatar();
            this.speechBubble.setHasAvatar(!!newTooltipInfo.avatar);
            if (newTooltipInfo.avatar !== undefined) {
                this.loadAvatar(newTooltipInfo.avatar);
            }
        }
        this.speechBubble.setTooltipPlacement(newTooltipInfo.placement);
        switch (newTooltipInfo.align) {
            case 0:
                this.speechBubble.setTextAlingment(SpeechBubbleTextAlingment.Left);
                break;
            case 1:
                this.speechBubble.setTextAlingment(SpeechBubbleTextAlingment.Center);
                break;
            case 2:
                this.speechBubble.setTextAlingment(SpeechBubbleTextAlingment.Right);
                break;
        }
        this.speechBubble.setColor(newTooltipInfo.color);
        this.speechBubble.setBorderColor(newTooltipInfo.borderColor);
        this.avatarTransNeedsUpdate = (oldTooltipInfo === undefined) || oldTooltipInfo.text !== newTooltipInfo.text;
    }
    updateTransform() { }
    updateAnchorPoint(anchorPoint) {
        this.anchorPoint.fromArray(anchorPoint);
    }
    show() {
        if ((this.speechBubble === undefined) || (this.facet === undefined))
            return;
        this.speechBubble.createTextInstance();
        this.speechBubble.setText(localizationService.getTranslation(this.facet.text));
        if (this.avatarTransNeedsUpdate) {
            this.avatarTransNeedsUpdate = false;
            this.speechBubble.updateAvatarPosition();
        }
        this.owner.renderer.addAnimationCallback(this.owner.modelUID, TooltipInfoFacet, () => {
            this.update();
        });
        this.speechBubble.setVisible(true);
    }
    hide() {
        this.owner.renderer.removeAnimationCallback(this.owner.modelUID, TooltipInfoFacet);
        if (this.speechBubble !== undefined) {
            this.speechBubble.destroyTextInstance();
            this.speechBubble.setVisible(false);
        }
    }
    update() {
        if ((this.facet === undefined) || (this.speechBubble === undefined)) {
            this.hide();
            return;
        }
        const scale = this.calculateScale();
        const orientation = this.calculateOrientation(scale * this.speechBubble.getVerticalOffset(), tmpOrientation);
        // the group-node that contains the background-mesh and the avatar-mesh
        // is positioned at the AnchorPoint
        this.speechBubble.setTransform(this.anchorPoint, orientation, scale);
    }
    calculateOrientation(verticalOffset, orientation) {
        const view = tmpVector3.subVectors(localPlayerContainer.cameraWorldPosition, this.anchorPoint);
        const dist = view.length();
        const pitch = 0.5 * Math.PI - Math.acos(view.y / dist) - Math.asin(verticalOffset / dist);
        const yaw = Math.atan2(-view.x, -view.z);
        orientation.setFromEuler(tmpEuler.set(pitch, yaw, 0, "YXZ"));
        return orientation;
    }
    calculateScale() {
        const distanceToCamera = this.anchorPoint.distanceTo(localPlayerContainer.cameraWorldPosition);
        return distanceToCamera * (renderManager.isXRPresenting() ? 0.5 : 0.3);
    }
    loadAvatar(avatarName) {
        this.owner.renderer.getConnection().ask(new LoadAvatarMessage(avatarName, AvatarStyle.Head), // Todo: Perhaps change this. This is more like a profile-picture than an Avatar...
        (messages) => {
            this.onLoadAvatarAnswer(messages, avatarName);
        });
    }
    onLoadAvatarAnswer(messages, avatarName) {
        var _a;
        const message = messages.length === 1 ? messages[0] : undefined;
        if ((message !== undefined) && AvatarLoadedMessage.is(message)) {
            (_a = this.speechBubble) === null || _a === void 0 ? void 0 : _a.setAvatar(message.headMesh);
        }
        else {
            console.error(`Failed on load avatar ${avatarName} with model uid ${this.owner.modelUID.toString()}`);
        }
    }
}
